import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { AppPageNoMaxWidth } from "@/layouts";
import { ActivitiesTableWithData } from "@/pages/UserDetails/components/CallPlans/CreateCallPlanModal/ActivitiesTable";

import {
  activitiesLibraryPageCreateButtonSx,
  activitiesLibraryPageFiltersSx,
  activitiesLibraryPageHeaderSx,
  activitiesLibraryPageHeadingSx,
  activitiesLibraryPageLayoutSx,
  activitiesLibraryPageTableWrapSx,
} from "./ActivitiesLibraryPage.styles";

export const ActivitiesLibraryPage = () => (
  <AppPageNoMaxWidth>
    <Box sx={activitiesLibraryPageLayoutSx}>
      <Box sx={activitiesLibraryPageHeaderSx}>
        <Typography component="h1" sx={activitiesLibraryPageHeadingSx}>
          Activities
        </Typography>
        <Button
          component={RouterLink}
          to="/activities/new"
          variant="contained"
          disableElevation
          sx={activitiesLibraryPageCreateButtonSx}
        >
          Create activity
        </Button>
      </Box>
      <ActivitiesTableWithData
        skip={false}
        libraryMode
        showQueryErrorAlert
        filterWrapSx={activitiesLibraryPageFiltersSx}
        mainColumnWrapSx={activitiesLibraryPageTableWrapSx}
      />
    </Box>
  </AppPageNoMaxWidth>
);
